import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  container: {
    position: "absolute",
    top: theme.spacing(8),
    left: "calc(100vw - 325px)",
    padding: "4px 0 10px",
    height: 108,
    width: 300,
    borderRadius: 5,
    background: theme.palette.white,
  },
  linearProgress: {
    width: 320,
    height: 7,
    borderTopLeftRadius: 48,
    borderTopRightRadius: 48,
    marginTop: "-4px",
    color: theme.palette.events.bluePrimary,
    background: theme.palette.events.blueAccent4,
    "& .MuiLinearProgress-bar": {
      background: theme.palette.events.bluePrimary,
    },
  },
  messageContent: {
    padding: "10px 5px 10px 10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  messageBox: {
    display: "flex",
    paddingBottom: "10px",
  },
  icon: {
    width: theme.spacing(3.75),
    height: theme.spacing(3.75),
    color: theme.palette.events.bluePrimary,
    "& rect": {
      color: theme.palette.events.blueAccent4,
    },
  },
  message: {
    marginLeft: theme.spacing(2),
  },
  cancelBox: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: theme.spacing(2),
  },
  cancelButton: {
    height: 28,
  },
  closeButton: {
    marginLeft: theme.spacing(1),
    "& svg": {
      width: theme.spacing(2),
      height: theme.spacing(2),
    },
  },
}));
